import React from "react";
import { InputLabelEditor } from "../../../../../components/InputLabelEditor";
import Dropzone from 'react-dropzone';
import { CreateChallengeStyles } from "../styles";
import { ChallengeLocalization } from "../types";

type IImageFields = 'imageUrl' | 'presentationImageUrl' | 'backgroundImageUrl'

type ChallengeImagePickerProps = {
  selectedLanguage: string;
  dataByLanguage: ChallengeLocalization | undefined;
  field: IImageFields;
  onChange:  (key: string, value: string | number | undefined) => void;
  onPostUpload: (acceptedFiles: any, onSuccess: (imageUrl: string) => void) => void;
  title: string;
  isRequired?: boolean;
};

const ChallengeImagePicker = ({selectedLanguage, dataByLanguage,field, onChange, onPostUpload, title, isRequired }: ChallengeImagePickerProps) => {
  return (
    <div style={CreateChallengeStyles.inputContainer}>
      <InputLabelEditor title={title} flag={selectedLanguage} isRequired={isRequired} />
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Dropzone
          style={CreateChallengeStyles.dropZone}
          onDrop={acceptedFiles => {
            const onSuccess = (imageUrl: string) => {
              onChange(`localization.${selectedLanguage}.${field}`, imageUrl);
            };
            onPostUpload(acceptedFiles[0], onSuccess)
          }}
        >
          <div>
            {!dataByLanguage?.[field] ? (
              <span>Parcourir ou Drag n Drop</span>
            ) : (
              <img src={dataByLanguage?.[field]} style={{ maxWidth: 360 }} alt="" />
            )}
          </div>
        </Dropzone>
        {dataByLanguage?.[field] && (
          <div
            onClick={() => onChange(`localization.${selectedLanguage}.${field}`, undefined)}
            style={CreateChallengeStyles.trashContainer}
          >
            <i style={{ color: 'white' }} className="fa fa-trash" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChallengeImagePicker;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/components/ChallengeImagePicker.tsx